import React from "react";
import { X, Quote } from "lucide-react";

interface QuoteBlockProps {
    text: string;
    onClear?: () => void;
}

const QuoteBlock: React.FC<QuoteBlockProps> = ({ text, onClear }) => {
    // Truncate text if it's too long for the UI
    const displayText = text.length > 250 ? text.substring(0, 250) + "..." : text;

    return (
        <div className="flex items-start gap-3 p-3 mb-2 bg-violet-50/80 border-l-4 border-violet-500 rounded-r-md backdrop-blur-sm animate-in slide-in-from-bottom-2 duration-200 w-full max-w-full">
            <Quote className="w-4 h-4 text-violet-500 mt-1 flex-shrink-0" />
            <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-700 italic line-clamp-3 break-words text-left">
                    "{displayText}"
                </p>
            </div>
            {onClear && (
                <button
                    onClick={onClear}
                    className="text-gray-400 hover:text-gray-600 hover:bg-black/5 rounded-full p-1 transition-colors"
                    aria-label="Remove quote"
                >
                    <X size={14} />
                </button>
            )}
        </div>
    );
};

export default QuoteBlock;
